var map = {
	"./comments.js": 3511,
	"./complaint.js": 3512,
	"./curriculum.js": 3513,
	"./feedbacks.js": 3514,
	"./lessons.js": 3515,
	"./likes.js": 3516,
	"./main.js": 3517,
	"./notices.js": 3518,
	"./payment.js": 3519,
	"./referral.js": 3520,
	"./settings.js": 3521,
	"./teacher.js": 3522,
	"./users.js": 3523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3510;